var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"datasource-chart"},[_c('svg',{staticClass:"datasource-chart__svg"})])}
var staticRenderFns = []

export { render, staticRenderFns }